module.exports = __webpack_public_path__ + "images/ico-video-act.svg?4afb89fcf71e207d0e2ee195831d24ce";